module.exports = __webpack_public_path__ + "img/volume-down-fill.9a3594f0.svg";